<template>
  <div>
    <CDropdown
      inNav
      class="c-header-nav-items"
      placement="bottom-end"
      add-menu-classes="pt-0"
    >
      <template #toggler>
        <CHeaderNavLink>
          <span style="height: 20px; color: gray">{{user_name}}
          &nbsp;&nbsp;&nbsp;
          <CIcon :height="20" name="cil-cog" /></span>
        </CHeaderNavLink>
      </template>
      <CDropdownHeader tag="div" class="text-center" color="light" v-if="is_freelancer">
        <strong>Mi Cuenta</strong>
      </CDropdownHeader>
      <span v-for="(item, index) in menu">
        <CDropdownItem v-if="!item.is_divider" :href="item.target">
          <CIcon :name="item.icon" /> {{item.label}}
        </CDropdownItem>
        <CDropdownDivider v-if="item.is_divider" />
      </span>
      <CDropdownItem @click="reload">
        <CIcon name="cil-reload" /> Sincronizar
      </CDropdownItem>
      <CDropdownItem v-if="page != 'my_visits' && page != 'my_paid_visits' && is_freelancer" @click="showMyVisits">
        <CIcon name="cil-calendar" /> Mis Visitas
      </CDropdownItem>
      <CDropdownItem v-if="(page == 'my_visits' || page == 'my_paid_visits') && is_freelancer" @click="showAvailables">
        <CIcon name="cil-calendar" /> Disponibles
      </CDropdownItem>
      <CDropdownItem v-if="is_freelancer" @click="openProfileModal">
        <CIcon name="cil-user" /> Mi Perfil
      </CDropdownItem>
      <CDropdownDivider/>
      <CDropdownItem v-if="force_login" @click="backToAdmin">
        <CIcon name="cil-lock-locked" /> Volver al Admin
      </CDropdownItem>
      <CDropdownItem v-if="!force_login" @click="logout">
        <CIcon name="cil-lock-locked" /> Cerrar Sesión
      </CDropdownItem>
    </CDropdown>

    <CModal
      title="Mi Perfil"
      color="info"
      :show.sync="show_profile_modal"
      size="md"
    >
      <CRow>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Escribe tu nombre"
            v-model="name"
            @input="name = name.toUpperCase()"
          />          
        </CCol>
      </CRow>
      <CRow v-if="is_freelancer">
        <CCol sm="12">
          <CSelect
            label="Banco"
            :value.sync="bank"
            :options="bankOptions"
            placeholder=""
          />
        </CCol>
        <CCol sm="12" v-if="showAccountField(bank)">
          <CInput
            v-model="account"
            label="No. de Cuenta"
            type="text"
            inputmode="numeric"
            placeholder=""
            @input="account = onlyDigits(account)"
            maxlength="18"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            v-model="clabe"
            label="Clabe Interbancaria"
            type="text"
            inputmode="numeric"
            placeholder=""
            @input="clabe = onlyDigits(clabe)"
            maxlength="18"
          />
        </CCol>
      </CRow>
      <template #footer>
        <CButton color="secondary" @click="closeProfileModal">Cerrar</CButton>
        <CButton color="info" @click="saveProfile">Actualizar Datos</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import router from '../router/index'
import store from '../store'
import account_ws from '../services/account';
import ws from '../services/general';
import operation_ws from '../services/operation';
import moment from 'moment';

export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      name: '',
      page: '',
      user_name: '',
      is_kam: 0,
      is_collaborator: 0,
      is_freelancer: 0,
      menu: [],
      today_visits: "today",
      force_login: false,
      admin_token: '',
      show_profile_modal: false,
      old_password: '',
      new_password: '',
      confirm_password: '',
      must_complete_bank_data: false,
      bank: 'BBVA',
      account: '',
      clabe: '',
      bankOptions: [
        {value: 'BBVA', label: 'BANCOMER (BBVA)'},
        {value: 'BANAMEX', label: 'BANAMEX'},
        {value: 'BANORTE', label: 'BANORTE'},
        {value: 'SANTANDER', label: 'SANTANDER'},
        {value: 'HSBC', label: 'HSBC'},
        {value: 'SCOTIABANK', label: 'SCOTIABANK'},
        {value: 'BANCOPPEL', label: 'BANCOPPEL'},
        {value: 'BANCO AZTECA', label: 'BANCO AZTECA'},
        {value: 'MERCADO PAGO', label: 'MERCADO PAGO'}
      ]
    }
  },
  mounted: async function() {
    const showProfileAfterLogin = localStorage.getItem("show_profile_after_login") == "1";
    localStorage.removeItem("show_profile_after_login");

    this.is_administrator = localStorage.getItem("is_administrator") == "false" ? 0 : 1;   
    this.is_kam = localStorage.getItem("is_kam") == "false" ? 0 : 1;   
    this.is_collaborator = localStorage.getItem("is_collaborator") == "false" ? 0 : 1;   
    this.is_freelancer = localStorage.getItem("is_freelancer") == "true" ? 1 : 0;
    this.today_visits = localStorage.getItem("today_visits");    
    this.force_login = localStorage.getItem("force_login") == "1" ? 1 : 0;
    this.admin_token = localStorage.getItem("admin_token");
    
    this.page = localStorage.getItem("page");

    await this.loadProfileData();

    if(showProfileAfterLogin && this.is_freelancer && this.must_complete_bank_data){
      this.show_profile_modal = true;
      this.showToast('warning', 'Completa tu información bancaria para continuar.');
    }
    
    // let response2 = await ws.getMenu("header"); 

    // if(response2.type == "success"){
    //   this.menu = response2.data;
    // }
  },
  methods: {
    reload: function(){
      localStorage.removeItem("last_login");

      location.reload();
    },
    backToAdmin () {
      if(window.location.hostname != 'localhost'){
        window.location = "https://circuito.tmkt3.com/#/"+this.admin_token+"/admin-login-link";
      }
      else{
        window.location = "http://"+window.location.hostname+":"+window.location.port+"/#/"+this.admin_token+"/admin-login-link";
      }
    },
    showAvailables: function(){
      localStorage.setItem("page", "branchs");

      location.reload();
    },
    showMyVisits: function(){
      localStorage.setItem("page", "my_visits");
      localStorage.setItem("my_visits_mode", "active");

      location.reload();
    },
    openProfileModal: async function(){
      await this.loadProfileData();
      this.old_password = '';
      this.new_password = '';
      this.confirm_password = '';
      this.show_profile_modal = true;
    },
    loadProfileData: async function(){
      let response = await account_ws.getInfo(); 

      if(response.type == "success"){
        this.name = response.data.first_name+" "+response.data.last_name;
        this.user_name = response.data.first_name+" "+response.data.last_name;

        const freelancer = Array.isArray(response.data.freelancer)
          ? (response.data.freelancer.length > 0 ? response.data.freelancer[0] : null)
          : response.data.freelancer;

        if(freelancer){
          const bank = freelancer.bank ? freelancer.bank.toString().trim().toUpperCase() : 'BBVA';
          this.bank = bank == 'BANCOMER' ? 'BBVA' : bank;
          this.account = freelancer.account !== null && freelancer.account !== undefined ? String(freelancer.account) : '';
          this.clabe = freelancer.clabe !== null && freelancer.clabe !== undefined ? String(freelancer.clabe) : '';

          this.must_complete_bank_data = this.hasMissingBankData(freelancer);
        }
        else{
          this.bank = 'BBVA';
          this.account = '';
          this.clabe = '';
          this.must_complete_bank_data = this.is_freelancer ? true : false;
        }
      }
    },
    hasMissingBankData: function(freelancer){
      const bank = freelancer && freelancer.bank ? freelancer.bank.toString().trim().toUpperCase() : '';
      const clabe = freelancer && freelancer.clabe !== null && freelancer.clabe !== undefined ? this.onlyDigits(freelancer.clabe) : '';
      const account = freelancer && freelancer.account !== null && freelancer.account !== undefined ? this.onlyDigits(freelancer.account) : '';

      if(bank == ''){
        return true;
      }

      if(!/^\d{18}$/.test(clabe)){
        return true;
      }

      if(this.isBancomerBank(bank) && !/^\d{10}$/.test(account)){
        return true;
      }

      return false;
    },
    closeProfileModal: function(){
      this.show_profile_modal = false;
    },
    saveProfile: async function(){
      let validation = this.validateProfileForm();
      if(!validation.valid){
        this.showToast('warning', validation.message);
        return;
      }

      this.loading();

      let response = await account_ws.setProfile({
        name: this.name.trim(),
        bank: this.bank,
        account: this.showAccountField(this.bank) ? this.onlyDigits(this.account) : '',
        clabe: this.onlyDigits(this.clabe)
      });

      if(response){
        this.showToast(response.type, response.message);

        if(response.type == 'success'){
          this.user_name = this.name.trim();
          this.must_complete_bank_data = false;

          this.closeProfileModal();
        }
      }

      this.loaded();
    },
    validateProfileForm: function(){
      if(!this.name || this.name.trim() == ''){
        return {
          valid: false,
          message: 'Debes escribir tu nombre.'
        };
      }

      if(this.is_freelancer){
        if(!this.bank || this.bank.trim() == ''){
          return {
            valid: false,
            message: 'Debes seleccionar un banco.'
          };
        }

        if(this.showAccountField(this.bank) && (!this.account || this.account.toString().trim() == '')){
          return {
            valid: false,
            message: 'Para BANCOMER debes capturar el número de cuenta.'
          };
        }

        if(this.showAccountField(this.bank)){
          const account = this.onlyDigits(this.account);
          if(!/^\d{10}$/.test(account)){
            return {
              valid: false,
              message: 'El número de cuenta debe tener exactamente 10 dígitos numéricos.'
            };
          }
        }

        if(!this.clabe || this.clabe.toString().trim() == ''){
          return {
            valid: false,
            message: 'Debes capturar la clabe interbancaria.'
          };
        }

        const clabe = this.onlyDigits(this.clabe);
        if(!/^\d{18}$/.test(clabe)){
          return {
            valid: false,
            message: 'La clabe interbancaria debe tener exactamente 18 dígitos numéricos.'
          };
        }

      }

      return {
        valid: true,
        message: ''
      };
    },
    isBancomerBank: function(bank){
      if(!bank){
        return false;
      }

      const value = bank.toString().trim().toUpperCase();

      return value == 'BANCOMER' || value == 'BBVA';
    },
    showAccountField: function(bank){
      return this.isBancomerBank(bank);
    },
    onlyDigits: function(value){
      if(value === null || value === undefined){
        return '';
      }

      return value.toString().replace(/\D/g, '');
    },
    savePassword: async function(){
      if(!this.old_password || !this.new_password){
        this.showToast('warning', 'Debes completar la contraseña actual y la nueva contraseña.');
        return;
      }

      if(this.new_password.length < 6){
        this.showToast('warning', 'La nueva contraseña debe tener al menos 6 caracteres.');
        return;
      }

      if(this.new_password != this.confirm_password){
        this.showToast('warning', 'La confirmación de contraseña no coincide.');
        return;
      }

      this.loading();

      let response = await account_ws.setPassword({
        old_password: this.old_password,
        new_password: this.new_password
      });

      if(response){
        this.showToast(response.type, response.message);

        if(response.type == 'success'){
          this.old_password = '';
          this.new_password = '';
          this.confirm_password = '';
        }
      }

      this.loaded();
    },
    chargeWeek: async function(){  
      this.loading();   
      localStorage.removeItem("last_login");
      router.push("/home/week");

      this.today_visits = "week";

      this.loaded();
    },
    chargeToday: async function(){  
      this.loading();   
      localStorage.removeItem("last_login");
      router.push("/home/today");
      
      this.today_visits = "today";

      this.loaded();
    },
    rrhhVisor: async function(){  
      this.loading();   
      window.location.href = "/#/rrhh"; this.loaded(); return;
      this.loaded();
    },
    logout: function(){
      localStorage.removeItem("token");
      localStorage.removeItem("last_login");
      store.commit('clear');
      router.push("login");
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>